import React, { PureComponent } from 'react';

class PassengerBar extends PureComponent{

  toggleStatusColour(status){
    return (status==="Confirmed") ? 'confirmed' : 'unconfirmed';
  }

  toggleStatusIcon(icon){
    switch (icon) {
      case 'default':
        return <img src="https://images.ctfassets.net/3ng3kfj0qs70/5Qp427jvRCoWWi6UK62w2s/ce3bc8dcd9c8fab1a9e9d1b7a71a374f/user-check-black.svg" alt="User icon"/>
      case 'completed':
        return <img src="https://images.ctfassets.net/3ng3kfj0qs70/1rFqf1OH5CicsIkmIqYuKA/9493232c353c8a5c260c8f635ceb1fc2/user-check-green.svg" alt="User icon"/>
      case 'error':
        return <img src="https://images.ctfassets.net/3ng3kfj0qs70/o2PzLk9hBIUEyGkq8qWeg/087a95c8de648f0c0793ff875ec57961/user-check-red.svg" alt="User icon"/>
    default:
    }
  }

  render(){
    return (
      <div className={`passenger-bar ${this.props.barClass}`}>
        <div className="row">
          <div className="column small-12">
            <div className="float-left">
                <p>{this.toggleStatusIcon(this.props.icon)}{this.props.title}</p>
            </div>
            <div className="float-right">
              <p className={ this.toggleStatusColour(this.props.status) }>{this.props.status}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default PassengerBar;



// WEBPACK FOOTER //
// ./src/components/confirmation/components/passengerbar.js